var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 15,
    cy: 15,
    r: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.315 8c.348 0 .63.392.63.875v5.179h5.18c.443 0 .809.237.867.545l.008.086v.63c0 .348-.392.63-.875.63h-5.18v5.18c0 .443-.236.809-.544.867l-.086.008h-.63c-.348 0-.63-.392-.63-.875l-.001-5.18H8.875c-.443 0-.809-.236-.867-.544L8 15.315v-.63c0-.348.392-.63.875-.63l5.179-.001V8.875c0-.443.237-.809.545-.867L14.685 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.47f2d0dd.svg";
export { ForwardRef as ReactComponent };